module.exports = __webpack_public_path__ + "img/corner-down-right.83c0c69f.svg";